import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RefineRow from '../RefineRow';
import RefineTitle from './RefineTitle';

const mapStateToProps = ({ api: { s3BasePath } }) => ({ s3BasePath });

const MultipleRefined = ({ bold, fontSize, removeFilters, isDesktop, ids, filterList, s3BasePath, title }) =>
  ids && ids.length > 0 ? (
    <div>
      <RefineTitle
        bold={bold}
        fontSize={fontSize}
        isDesktop={isDesktop}
        padding={isDesktop ? '5px 0 0 0' : '5px 5px 0 5px'}
        title={title}
      />
      {filterList.map(filter => (
        <RefineRow
          key={`filter_${filter.text}`}
          isDesktop={isDesktop}
          label={filter.text === 'U' ? 'ONE SIZE' : filter.text}
          onClick={() => removeFilters(filter.data)}
          s3BasePath={s3BasePath}
        />
      ))}
    </div>
  ) : null;

MultipleRefined.propTypes = {
  bold: PropTypes.bool,
  filterList: PropTypes.array,
  fontSize: PropTypes.number,
  ids: PropTypes.array,
  isDesktop: PropTypes.bool,
  removeFilters: PropTypes.func,
  s3BasePath: PropTypes.string,
  title: PropTypes.string,
};

export default connect(mapStateToProps)(MultipleRefined);
